// Admin.jsx
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import axios from "api/axios";
import AdminNotifications from "views/admin/raport/components/AdminNotifications";

export default function Admin(props) {
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const [currentRoute, setCurrentRoute] = useState("Dashboard");
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get("/api/account/current-user", {
          headers: { Authorization: `Bearer ${token.replace(/"/g, "")}` },
        });

        setUserRole(res.data.role); // adjust if role is in another field
      } catch (err) {
        console.error("Failed to fetch user role:", err);
      }
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // run once on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].layout + "/" + routes[i].path) !== -1) {
        setCurrentRoute(routes[i].name);
        return;
      }
    }
    setCurrentRoute("Dashboard");
  };

  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].secondary || false;
      }
    }
    return false;
  };

  const filteredRoutes = routes.filter((route) => {
    if (route.layout !== "/admin") return false;
    if (!route.allowedRoles) return true; // open to all roles if no restriction
    if (!userRole) return false; // don't show until role is loaded
    if (Array.isArray(route.allowedRoles)) {
      return route.allowedRoles.includes(userRole);
    }
    return route.allowedRoles === userRole;
  });

  const getRoutes = (routesArr) =>
    routesArr.map((prop, key) => (
      <Route path={`/${prop.path}`} element={prop.component} key={key} />
    ));

  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} userRole={userRole} />
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        <main className="mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]">
          <div className="h-full">
            {/* <AdminNotifications /> */}
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"OmniRep"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              notifications={props.notifications}
              setNotifications={props.setNotifications}
              {...props}
            />

            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(filteredRoutes)}

                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboard" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

